import { render, staticRenderFns } from "./ChangguanZhanhuiStatBlock.vue?vue&type=template&id=1cf06f89&scoped=true"
import script from "./ChangguanZhanhuiStatBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanZhanhuiStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ChangguanZhanhuiStatBlock.vue?vue&type=style&index=0&id=1cf06f89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf06f89",
  null
  
)

export default component.exports